import React from 'react';
import { Client as GraphClient } from '@microsoft/microsoft-graph-client';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose, pure, lifecycle, withState } from 'recompose';
import { selectUser } from '../../../selectors';
import request from '../../../utils/api';

import { API } from '../../../constants/api';

const Office = ({ people, groups, events, drives, items, contacts }) => (
  <div>
    <div>Office</div>
    <div>People</div>
    <ul>
      {people.map(person => (
        <li key={person.id}>{person.displayName} </li>
      ))}
    </ul>
    <div>Contacts</div>
    <ul>
      {contacts.map(contact => (
        <li key={contact.id}>{contact.displayName} </li>
      ))}
    </ul>
    <div>Groups</div>
    <ul>
      {groups.map(group => (
        <li key={group.id}>{group.displayName} </li>
      ))}
    </ul>
    <div>Events</div>
    <ul>
      {events.map(group => (
        <li key={group.id}>
          {group.subject} - {group.start.dateTime}
        </li>
      ))}
    </ul>
    <div>Drives</div>
    <ul>
      {drives.map(drive => (
        <li key={drive.id}>{drive.name}</li>
      ))}
    </ul>
    <div>Items</div>
    <ul>
      {items.map(item => (
        <li key={item.id}>
          {item.folder &&
            `Carpeta: ${item.name} - Hijos ${item.folder.childCount}`}
          {item.file && (
            <div>
              <a href={item.webUrl} target="_blanck">
                {item.name}
              </a>
              {'  '}
              <a href={item['@microsoft.graph.downloadUrl']} target="_blanck">
                Download
              </a>
            </div>
          )}
        </li>
      ))}
    </ul>
  </div>
);

Office.propTypes = {};

export default compose(
  withState('people', 'setPeople', []),
  withState('groups', 'setGroups', []),
  withState('events', 'setEvents', []),
  withState('drives', 'setDrives', []),
  withState('items', 'setItems', []),
  withState('contacts', 'setContacts', []),
  connect(
    createSelector(
      selectUser(),
      user => ({
        user
      })
    ),
    null
  ),
  lifecycle({
    componentDidMount() {
      const {
        setPeople,
        setGroups,
        setEvents,
        setItems,
        setDrives,
        setContacts
      } = this.props;

      request(`${API}/token`).then(token => {
        const client = GraphClient.init({
          authProvider: done => {
            if (typeof token.access_token === 'undefined') {
              done({ err: 'No auth token' });
            } else {
              done(null, token.access_token); // first parameter takes an error if you can't get an access token
            }
          }
        });
        client
          .api('me/people')
          .top(5)
          .get((err, res) => {
            if (res) {
              setPeople(res.value);
            }
          });
        client
          .api('me/memberOf')
          .top(5)
          .get((err, res) => {
            if (res) {
              setGroups(res.value);
            }
          });
        client
          .api('me/events')
          .top(5)
          .get((err, res) => {
            if (res) {
              setEvents(res.value);
            }
          });
        client
          .api('drives')
          .top(5)
          .get((err, res) => {
            if (res) {
              setDrives(res.value);
            }
          });
        client
          .api('/me/drive/root/children')
          .top(5)
          .get((err, res) => {
            if (res) {
              setItems(res.value);
            }
          });
        client
          .api('/me/contacts')
          .top(5)
          .get((err, res) => {
            if (res) {
              setContacts(res.value);
            }
          });
      });
    }
  }),
  pure
)(Office);
